import React from 'react'
import Banner from './Banner/Banner'
import Coinstable from './Banner/Coinstable'

const Home = () => {
  return (
    <div>
      <Banner/>
      <Coinstable/>
    </div>
  )
}

export default Home